import "./dashboard.scss";

import { useEffect, useState } from "react";
import { useAuth } from "../../authentication/authHelpers";
import LoaderComponent from "../commonComponents/LoadableComp/LoadableComp";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import UserDashboard from "./UserDashboard";
import ModalAnnounce from "../Announcement/ModalAnnounce/ModalAnnounce";
import AquamanModal from "./components/aquamanWidget/AquamanModal";

function DashboardBase() {
  const auth = useAuth();
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState(null);

  useEffect(() => {
    if (auth.userAccess.length > 0) {
      const role = auth.userAccess[0].userRole;
      if (
        role === "Admin" ||
        role === "Super Admin" ||
        role === "Branch Manager"
      ) {
        setViewType("Admin");
      } else {
        setViewType("User");
      }
      setLoading(false);
    }
  }, [auth]);

  return (
    <LoaderComponent loading={loading}>
      {viewType === "Admin" ? (
        <AdminDashboard />
      ) : viewType === "User" ? (
        <UserDashboard role={auth?.userAccess[0]?.userRole || "User"} />
      ) : (
        <></>
      )}
      <ModalAnnounce open={true} />
      {/* Renders nothing unless the signed-in employee is this week's assignee. */}
      <AquamanModal />
    </LoaderComponent>
  );
}
export default DashboardBase;
